import React from "react";
import { Link } from "react-router-dom";
import { Portfolio } from "../ui/HomePageStyles";

//gallery headers
import gallery_header from "../img/gallery_headers/gallery.png";
import public_art_header from "../img/gallery_headers/public_art.png";
import client_work_header from "../img/gallery_headers/client_work.jpg";

function HomePage() {
  return (
    <Portfolio className="container">
      <div className="row row-centered tight-cols">
        <div className="col-md-4 col-sm-4 col-xs-12 col-centered">
          <div className="thumbnail gallery-link">
            <Link to="gallery/collection">
              <div
                className="image"
                style={{ backgroundImage: "url(" + gallery_header + ")" }}
              />
            </Link>
            <p className="gallery-link-label">gallery</p>
          </div>
        </div>
        <div className="col-md-4 col-sm-4 col-xs-12 col-centered">
          <div className="thumbnail gallery-link">
            <Link to="gallery/public_art">
              <div
                className="image"
                style={{ backgroundImage: "url(" + public_art_header + ")" }}
              />
            </Link>
            <p className="gallery-link-label">public art</p>
          </div>
        </div>
        <div className="col-md-4 col-sm-4 col-xs-12 col-centered">
          <div className="thumbnail gallery-link">
            <Link to="gallery/client_work">
              <div
                className="image"
                style={{ backgroundImage: "url(" + client_work_header + ")" }}
              />
            </Link>
            <p className="gallery-link-label">client work</p>
          </div>
        </div>
      </div>
    </Portfolio>
  );
}

export default HomePage;
